import React from 'react';

function CardGroup({ cardData }) {
    return (
        <div className="transaction-cards-container">
            {cardData.map((card, index) => (
                <div
                    key={index}
                    style={{
                        backgroundImage: `url(${card.background})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        borderRadius: '10px',
                        color: '#000',
                        padding: '1.5rem',
                        transition: 'transform 0.3s ease',
                    }}
                    className="sales-card"
                >
                    <div className="sales-value ellipsis">{card.value}</div>
                    <div className="sales-label ellipsis">{card.label}</div>
                </div>
            ))}
        </div>
    );
}

export default CardGroup;
